import {AfterContentInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {ResumoVo} from '~model/vo/resumo-vo';
import {ResumoPoiVo} from '~model/vo/resumo-poi-vo';
import {utils as xlsUtils, WorkBook, WorkSheet, writeFile as writeXls} from 'xlsx';
import {PAE, prioridadePAE} from '~model/vo/visita-vo';
import {toNumber} from '~utils/time-utils';

@Component({
  selector: 'app-resumo-rota',
  templateUrl: './resumo-rota.component.html',
  styleUrls: ['./resumo-rota.component.scss'],
})
export class ResumoRotaComponent implements AfterContentInit {
  @Input() resumo!: ResumoVo;
  @ViewChild('resumoDiv', {static: false}) private resumoDiv!: ElementRef;
  dadosVisitas: { lista: ResumoPoiVo[], tipo: string, distancia: number, tempo: string }[] = [];

  constructor(
  ) {
  }

  ngAfterContentInit(): void {
    this.dadosVisitas.push({
      tipo: 'Planejado',
      distancia: this.resumo.planejado.distancia,
      tempo: this.resumo.planejado.tempo,
      lista: this.resumo.resumoPOIs.filter(i => i.tipo === 'TIPO_PEDIDO').map(v => ({ ...v, status: v.tipoOrigem !== "ROTA" ? "AVULSO" : 'PLANEJADO' })),
    });
    this.dadosVisitas.push({
      tipo: 'Executado',
      distancia: this.resumo.executado.distancia,
      tempo: this.resumo.executado.tempo,
      lista: this.resumo.resumoPOIs
        .filter(i => i.tipo === 'TIPO_PEDIDO')
        .map(v => ({ ...v, status: this.verificaStatus(v) }))
        .sort((poiA: ResumoPoiVo, poiB: ResumoPoiVo) => this.orderResumo(poiA, poiB))
        .map((v, index) => ({ ...v, ordem: (v.cancelado || v.removido ? 0 : index + 1), status: this.verificaStatus(v) })),
    });
  }

  baixarXls(): void {
    const ws: WorkSheet = xlsUtils.table_to_sheet(this.resumoDiv.nativeElement);
    const wb: WorkBook = xlsUtils.book_new();
    ws['!cols'] = [{wch: 5}, {wch: 20}, {wch: 20}, {wch: 50}, {wch: 15}, {wch: 8}, {wch: 8}];
    ws['!margins'] = {header: 1, footer: 1, bottom: 1, left: 1, right: 1, top: 1};
    // ws.A1.s = {fgColor: {rgb: `ED7D31`, patternType: 'solid'}};
    ws.C4.v = (ws.C4.v.includes('R$') ? '' : 'R$ ') + ws.C4.v;
    xlsUtils.book_append_sheet(wb, ws, 'Resumo');
    const name = `Resumo Planejado x Executado - ${this.resumo.placa} - ${this.resumo.data}.xlsx`;
    writeXls(wb, name);
  }

  print(): void {
    window.print();
  }

  prioridade(hora: PAE<string>, tipo: string): string {
    return (tipo === 'Planejado') ? `${hora.planejado ?? '-'}` : `${hora.executado ?? hora.atualizado ?? '-'}`;
  }

  verificaStatus(poi:ResumoPoiVo):string{
    if(poi.cancelado){
      return 'CANCELADA';
    }else if(poi.removido){
      return 'REMOVIDA';
    }else{
      return poi.status;
    }
  }
  
  orderResumo(poiA: ResumoPoiVo, poiB: ResumoPoiVo): number {
    // Check for 'CANCELADA' or 'REMOVIDA' status and push them to the end
    const isPoiACanceledOrRemoved = poiA.status === 'CANCELADA' || poiA.status === 'REMOVIDA';
    const isPoiBCanceledOrRemoved = poiB.status === 'CANCELADA' || poiB.status === 'REMOVIDA';

    if (isPoiACanceledOrRemoved && !isPoiBCanceledOrRemoved) {
      return 1; // poiA goes after poiB
    }

    if (!isPoiACanceledOrRemoved && isPoiBCanceledOrRemoved) {
      return -1; // poiA goes before poiB
    }

    // If both or neither are 'CANCELADA' or 'REMOVIDA', sort by horaChegada
    const timeA = prioridadePAE(poiA.horaChegada) || "00:00";
    const timeB = prioridadePAE(poiB.horaChegada) || "00:00";

    const numA = toNumber(timeA);
    const numB = toNumber(timeB);

    if (numA < numB) {
      return -1;
    }
    if (numA > numB) {
      return 1;
    }
    return 0;
  }
}
